import { render } from "./page_07.vue?vue&type=template&id=40a5a224"
import script from "./page_07.vue?vue&type=script&lang=js"
export * from "./page_07.vue?vue&type=script&lang=js"
script.render = render

export default script